<div class="app-tooltip-overlay" *transloco="let t" style="--tooltip-toggle-height: {{toogleHeight}}px">
  <div class="app-tooltip-overlay__text-container">
    <mat-label class="app-tooltip-overlay__label app-tooltip-overlay__header">{{
      t("step3.eh-mydocuments-step3-custom-tooltip-header")
    }}</mat-label>
    <mat-label class="app-tooltip-overlay__label">{{
      t("step3.eh-mydocuments-step3-custom-tooltip")
    }}</mat-label>
  </div>
  <button
    class="app-tooltip-overlay__button"
    mat-raised-button
    (click)="close()"
  >
    {{ t("step3.eh-mydocuments-step3-custom-tooltip-button") }}
  </button>
</div>

<div class="app-tooltip-overlay__fake-toggle-container">
  <app-customize-toggle [overlayMode]="true"></app-customize-toggle>
</div>
